import React, { useState } from 'react';
import ResizeAvatar from './ResizeAvatar';
import Dropzone from 'react-dropzone';

const AvatarDropZone = ({ input: { value, onChange }, meta, uploadTitle, customHeight }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const files = value;
  const onDrop = (files) => {
    const file = files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);       
      setModalOpen(true);              
    };
    reader.readAsDataURL(file);
  };

  const handleCropped = (croppedFile) => {
    croppedFile.preview = URL.createObjectURL(croppedFile);
    onChange([croppedFile]); 
    setModalOpen(false);
  };

  const removeFile = (index, e) => {
    e.preventDefault();
    onChange(value.filter((val, i) => i !== index));
  };


  let showTitle = false;
  if (uploadTitle?.displayAlways){
    showTitle = true
  } else if (!files || files.length === 0) {
    showTitle = true;
  }
  let title = {icon : <span className="lnr lnr-upload" />, text: 'Drop file here to upload'};
  if (uploadTitle?.type){
    if(uploadTitle.type === 'short'){
      title = {icon: <span className="lnr lnr-upload" />, text: ''};
    }
  }

  return (
    <div className={`dropzone dropzone--single${customHeight ? ' dropzone--custom-height' : ''}`}>
      <Dropzone
        accept="image/jpeg, image/png"
        multiple={false}
        resizeWidth="200"
        onDrop={(fileToUpload) => {
          onDrop(fileToUpload);
        }}
      >
        {({ getRootProps, getInputProps }) => (
          <div {...getRootProps()} className="dropzone__input">
            {(showTitle)
            && (
              <div className="dropzone__drop-here">
                {title.icon} {title.text}
              </div>
            )}
            <input {...getInputProps()} />
          </div>
        )}
      </Dropzone>
      {value && value.length > 0
      && (
        <aside className="dropzone__img">
          <img src={value[0].preview} alt="drop-img" />
          <p className="dropzone__img-name">{value[0].name}</p>
          <button className="dropzone__img-delete" type="button" onClick={e => removeFile(0, e)}>
            Remove
          </button>
        </aside>
      )}

      <ResizeAvatar
        isOpen={isModalOpen}
        toggle={() => setModalOpen(false)}
        imageSrc={imageSrc}
        onCropped={handleCropped}
      />

      {meta.touched && meta.error && <span className="text-danger">{meta.error}</span>}
    </div>
  );
};

export default AvatarDropZone;